import React, { useEffect, useState } from "react";
import Header from "../../components/Headers/Header";
import {
  Container,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Row,
  Col,
  Input,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { getSinglePlayer } from "store/actions/playerActions";
import { getSinglePlayerLicenses } from "store/actions/playerActions";
import moment from "moment";

function PlayerDetail(props) {
  const [byYear, setByYear] = useState(new Date().getFullYear());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  let { singlePlayer } = useSelector((state) => state.players);
  let { singlePlayerLicense } = useSelector((state) => state.players);
  const getMonthlySale = () => {
    let monthlySale = [];
    let jan = [];
    let feb = [];
    let march = [];
    let april = [];
    let may = [];
    let june = [];
    let july = [];
    let aug = [];
    let sep = [];
    let oct = [];
    let nov = [];
    let dec = [];
    let finalDate;
    singlePlayerLicense.length > 0 &&
      singlePlayerLicense.forEach((lic) => {
        let d = lic.created_at;
        let date = new Date(moment.unix(d.seconds).toLocaleString());
        let options = { year: "numeric", month: "short" };
        finalDate = date.toLocaleString("en-us", options);
        switch (finalDate) {
          case `Jan ${byYear}`:
            return jan.push({
              Month: finalDate,
              Price:
                Number(lic.amount.value) -
                (Number(lic.amount.value) * 50) / 100,
            });
          case `Feb ${byYear}`:
            return feb.push({
              Month: finalDate,
              Price:
                Number(lic.amount.value) -
                (Number(lic.amount.value) * 50) / 100,
            });
          case `Mar ${byYear}`:
            return march.push({
              Month: finalDate,
              Price:
                Number(lic.amount.value) -
                (Number(lic.amount.value) * 50) / 100,
            });
          case `Apr ${byYear}`:
            return april.push({
              Month: finalDate,
              Price:
                Number(lic.amount.value) -
                (Number(lic.amount.value) * 50) / 100,
            });
          case `May ${byYear}`:
            return may.push({
              Month: finalDate,
              Price:
                Number(lic.amount.value) -
                (Number(lic.amount.value) * 50) / 100,
            });
          case `Jun ${byYear}`:
            return june.push({
              Month: finalDate,
              Price:
                Number(lic.amount.value) -
                (Number(lic.amount.value) * 50) / 100,
            });
          case `Jul ${byYear}`:
            return july.push({
              Month: finalDate,
              Price:
                Number(lic.amount.value) -
                (Number(lic.amount.value) * 50) / 100,
            });
          case `Aug ${byYear}`:
            return aug.push({
              Month: finalDate,
              Price:
                Number(lic.amount.value) -
                (Number(lic.amount.value) * 50) / 100,
            });
          case `Sep ${byYear}`:
            return sep.push({
              Month: finalDate,
              Price:
                Number(lic.amount.value) -
                (Number(lic.amount.value) * 50) / 100,
            });
          case `Oct ${byYear}`:
            return oct.push({
              Month: finalDate,
              Price:
                Number(lic.amount.value) -
                (Number(lic.amount.value) * 50) / 100,
            });
          case `Nov ${byYear}`:
            return nov.push({
              Month: finalDate,
              Price:
                Number(lic.amount.value) -
                (Number(lic.amount.value) * 50) / 100,
            });
          case `Dec ${byYear}`:
            return dec.push({
              Month: finalDate,
              Price:
                Number(lic.amount.value) -
                (Number(lic.amount.value) * 50) / 100,
            });
          default:
            return "NO Data";
        }
      });
    monthlySale = [
      {
        Month: "Jan",
        Price: jan.reduce((acc, cur) => acc + cur.Price, 0),
      },
      {
        Month: "Feb",
        Price: feb.reduce((acc, cur) => acc + cur.Price, 0),
      },
      {
        Month: "Mar",
        Price: march.reduce((acc, cur) => acc + cur.Price, 0),
      },
      {
        Month: "Apr",
        Price: april.reduce((acc, cur) => acc + cur.Price, 0),
      },
      {
        Month: "May",
        Price: may.reduce((acc, cur) => acc + cur.Price, 0),
      },
      {
        Month: "Jun",
        Price: june.reduce((acc, cur) => acc + cur.Price, 0),
      },
      {
        Month: "Jul",
        Price: july.reduce((acc, cur) => acc + cur.Price, 0),
      },
      {
        Month: "Aug",
        Price: aug.reduce((acc, cur) => acc + cur.Price, 0),
      },
      {
        Month: "Sep",
        Price: sep.reduce((acc, cur) => acc + cur.Price, 0),
      },
      {
        Month: "Oct",
        Price: oct.reduce((acc, cur) => acc + cur.Price, 0),
      },
      {
        Month: "Nov",
        Price: nov.reduce((acc, cur) => acc + cur.Price, 0),
      },
      {
        Month: "Dec",
        Price: dec.reduce((acc, cur) => acc + cur.Price, 0),
      },
    ];
    return monthlySale;
  };
  let dispatch = useDispatch();
  const handlePrint = (e, divPrint) => {
    var printContents = document.getElementById(divPrint).innerHTML;
    var originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    document.body.innerHTML = originalContents;
    window.location.reload();
  };
  useEffect(() => {
    dispatch(getSinglePlayer(props.match.params.id));
    dispatch(getSinglePlayerLicenses(props.match.params.id));
  }, []);
  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        {Object.keys(singlePlayer).length > 0 && (
          <Card>
            <CardHeader>
              <Row className="no-gutters">
                <Col md="3" xs={12}>
                  <CardTitle>{singlePlayer.name} </CardTitle>
                  <CardSubtitle>
                    {singlePlayer.sport} | {singlePlayer.state}
                  </CardSubtitle>
                </Col>
                <Col md="3" xs="5" className="mt-3 mt-md-0">
                  <CardSubtitle className="mt-1">Personal ID:</CardSubtitle>
                  <CardSubtitle className="mt-1">Email ID:</CardSubtitle>
                </Col>
                <Col md="3" xs="7" className="mt-3 mt-md-0">
                  <CardSubtitle className="mt-1">
                    {singlePlayer.athleteID}{" "}
                  </CardSubtitle>
                  <CardSubtitle className="mt-1">
                    {singlePlayer.email}
                  </CardSubtitle>
                </Col>
                <Col md="3" align="end" className="mt-3 mt-md-0">
                  <div className="d-flex d-sm-block">
                    <Button
                      className="custom-btn"
                      onClick={(e) => handlePrint(e, "divToPrint")}
                    >
                      Download
                    </Button>
                    <Button
                      className="custom-btn"
                      onClick={(e) => handlePrint(e, "divToPrint")}
                    >
                      Print
                    </Button>
                  </div>
                </Col>
              </Row>
            </CardHeader>
            <div id="divToPrint">
              <CardBody>
                <Row className="no-gutters">
                  <Col md="10" xs="8">
                    <p className="custom-filter-heading mb-sm-0">By Month</p>
                  </Col>
                  <Col md="2" xs="4">
                    <p className="custom-filter-heading ml-auto mb-sm-0 text-right">
                      By Year
                    </p>
                  </Col>
                </Row>
                <Row className="no-gutters">
                  <Col md="10" xs="8">
                    <Row>
                      {getMonthlySale().map((sale, index) => {
                        return (
                          <Col
                            lg="2"
                            md="3"
                            sm="4"
                            xs="6"
                            className="mt-3"
                            key={index}
                          >
                            <CardSubtitle className="text-dark-1">
                              {sale.Month}
                            </CardSubtitle>
                            <CardSubtitle className="mt-2">
                              ${sale.Price.toFixed(2)}
                            </CardSubtitle>
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                  <Col md="2" xs="4" className="mt-3">
                    <CardSubtitle className="text-right text-primary">
                      <Input
                        type="select"
                        value={byYear}
                        onChange={(e) => setByYear(e.target.value)}
                      >
                        <option value={currentYear}>{currentYear}</option>
                        <option value={currentYear - 1}>
                          {currentYear - 1}
                        </option>
                        <option value={currentYear - 2}>
                          {currentYear - 2}
                        </option>
                      </Input>
                    </CardSubtitle>
                  </Col>
                </Row>
              </CardBody>
            </div>
          </Card>
        )}
      </Container>
    </>
  );
}

export default PlayerDetail;
